import { useMemo } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { type ExternalUserServiceIntegration } from '../../../models/User'
import { useGetMeQuery } from '../../../store/user/user'
import { IntegrationServiceId } from '../../../common/integrations'

export const DelegatedEmailIntegrationState: React.FC<{
  serviceId: IntegrationServiceId
  currentIntegration?: ExternalUserServiceIntegration
  className?: string
}> = ({ className }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: userData } = useGetMeQuery({ accountId })

  const delegatedEmailLiveCount = useMemo(() => {
    return userData?.integrations?.filter((i) => i.serviceId === IntegrationServiceId.DELEGATED_EMAIL && i.state === 'live').length ?? 0
  }, [userData])

  if (!delegatedEmailLiveCount) return null

  return (
    <div className={`zocks-text-success ${className}`}>
      <i className='bi bi-check fs-5' />
      <span>{delegatedEmailLiveCount === 1 ? '1 email linked' : `${delegatedEmailLiveCount} emails linked`}</span>
    </div>
  )
}
